import { observe } from './observe';

document.addEventListener('DOMContentLoaded', () => {
  observe();
});
